import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import perfilImg from '../../assets/images/perfil.png';

import {
  FaWhatsapp, FaArrowRight, FaBrain, FaHeart, FaFistRaised, FaTools, FaLightbulb,
  FaRunning, FaCalendarAlt, FaFire, FaRegSurprise, FaUserAltSlash, FaInstagram, FaYoutube,
  FaCheckCircle, FaTimesCircle, FaSun, FaLeaf, FaSeedling, FaStar
} from "react-icons/fa"; // Añadidos más iconos para beneficios
import { FiCompass } from "react-icons/fi";


const transformationData = [
  { before: "Creencias limitantes", after: "Creencias empoderantes", beforeIcon: <FaLightbulb />, afterIcon: <FaBrain /> },
  { before: "Emociones de miedo", after: "Confianza y amor", beforeIcon: <FaRegSurprise />, afterIcon: <FaHeart /> },
  { before: "Hábitos que drenan energía", after: "Hábitos que impulsan tu poder", beforeIcon: <FaFistRaised />, afterIcon: <FaFire /> },
  { before: "No tener herramientas", after: "Dominar recursos holísticos", beforeIcon: <FiCompass />, afterIcon: <FaTools /> },
  { before: "Parálisis por inacción", after: "Accionar con claridad y fluidez", beforeIcon: <FaUserAltSlash />, afterIcon: <FaRunning /> },
];

const benefits = [
  { text: "Dormir mejor gracias a técnicas de respiración consciente.", icon: <FaSun /> }, // Icono añadido
  { text: "Eliminar creencias ocultas que generan procrastinación y malas decisiones.", icon: <FaLeaf /> }, // Icono añadido
  { text: "Crear hábitos diarios que aumentan tu energía y claridad mental.", icon: <FaSeedling /> }, // Icono añadido
  { text: "Descubrir un propósito de vida conectado a lo que realmente sos.", icon: <FaStar /> }, // Icono añadido
  { text: "Autogestionar tus emociones con herramientas simples de meditación.", icon: <FaStar /> } // Icono añadido
];

const testimonials = [
  { text: "Gracias a este proceso comprendí mi poder de elección y sanación.", author: "Gladys R.", role: "Artista" },
  { text: "Ahora puedo encontrar mi paz interior todas las mañanas.", author: "Ricardo A.", role: "Emprendedor" },
  { text: "Me ayudó a ver mis bloqueos desde otra perspectiva y liberarlos.", author: "Laura M.", role: "Emprendedora" }
];

// FAQS modificadas: Se ha retirado la pregunta del precio
const faqs = [
  { q: "¿Necesito experiencia previa?", a: "No, empezamos desde cero y avanzamos paso a paso." },
  { q: "¿Cuánto tiempo dura el programa?", a: "5 Semanas" },
  { q: "¿Qué incluye?", a: "1 Sesión de coaching semanal. Teoría, Práctica y Plan de acción." }
];

const TransformationButton = ({ beforeText, afterText, beforeIcon, afterIcon, index }) => (
  <div
    className="w-full max-w-lg mx-auto mb-3 flex items-center justify-center space-x-2 sm:space-x-3 fade-in-up"
    style={{ animationDelay: `${index * 120 + 500}ms` }} // Ajuste en el delay
  >
    <div className="flex items-center px-3 py-2 rounded-xl border border-gray-700 bg-black/40 text-white font-medium text-sm sm:text-base shadow-md shadow-gray-700/30 flex-1 hover:bg-gray-800 transition-all duration-300 ease-in-out">
      <span className="flex items-center justify-between w-full gap-2">
        {beforeIcon && <span className="text-lg text-gray-400">{beforeIcon}</span>}
        <span className="text-left flex-1 ml-2 text-gray-200">{beforeText}</span> {/* Texto más claro */}
      </span>
    </div>

    <FaArrowRight className="text-gray-500 text-lg sm:text-xl" />

    <div className="flex items-center px-3 py-2 rounded-xl border border-gray-700 bg-black/40 text-white font-medium text-sm sm:text-base shadow-md shadow-gray-700/30 flex-1 hover:bg-gray-800 transition-all duration-300 ease-in-out">
      <span className="flex items-center justify-between w-full gap-2">
        <span className="text-left flex-1 text-[#FFD700]">{afterText}</span> {/* CAMBIO: text-yellow-300 a text-[#FFD700] */}
        {afterIcon && <span className="text-lg text-[#FFD700]">{afterIcon}</span>} {/* CAMBIO: text-yellow-300 a text-[#FFD700] */}
      </span>
    </div>
  </div>
);

const InViewSection = ({ title, children, index, id }) => ( // Añadido id para posible navegación
  <section
    id={id} // Para posibles anclas
    className="w-full max-w-lg mx-auto mb-12 p-6 rounded-xl border border-gray-700 bg-black/40 shadow-xl shadow-gray-900/50 fade-in-up" // Sombra más profunda y padding
    style={{ animationDelay: `${index * 150 + 700}ms` }} // Ajuste en el delay
  >
    <h3 className="text-2xl font-bold mb-5 text-center text-[#FFD700] border-b border-gray-700 pb-3">{title}</h3> {/* CAMBIO: text-yellow-300 a text-[#FFD700] */}
    {children}
  </section>
);

const CTAButtons = ({ delay }) => (
  <div
    className="flex flex-col sm:flex-row justify-center items-center gap-4 mt-8 w-full max-w-md fade-in-up"
    style={{ animationDelay: `${delay}ms` }}
  >
    <a
      href={`https://wa.me/5491150254270?text=${encodeURIComponent("Hola Gustavo, quiero liberar mis bloqueos y necesito más información.")}`}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center justify-center px-7 py-3 rounded-xl border border-green-600 bg-green-700/60 text-white font-bold text-lg shadow-lg shadow-green-700/40 hover:bg-green-600 hover:scale-105 transition-all duration-300 ease-in-out w-full sm:w-auto" // Botones más grandes y con hover
    >
      <FaWhatsapp className="mr-3 text-2xl" /> Quiero empezar ahora
    </a>

    <div className="flex flex-col items-center w-full sm:w-auto">
      <a
        href="https://calendly.com/gustavonahuelaguiar/30min"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center px-7 py-3 rounded-xl border border-purple-600 bg-purple-700/60 text-white font-bold text-lg shadow-lg shadow-purple-700/40 hover:bg-purple-600 hover:scale-105 transition-all duration-300 ease-in-out w-full sm:w-auto" // Botones más grandes y con hover
      >
        <FaCalendarAlt className="mr-3 text-2xl" /> Agendar sesión gratuita
      </a>
      <span className="text-xs text-gray-400 mt-1">Cupos limitados – sin compromiso</span>
    </div>
  </div>
);

const MainCoursePage = () => {
  const { user } = useAuth();

  return (
    <div className="bg-black text-white min-h-screen font-sans flex flex-col relative overflow-hidden"> {/* overflow-hidden para evitar scrollbars inesperadas por animaciones */}
      <div className="fixed inset-0 bg-gradient-to-br from-gray-950 via-black to-gray-900 opacity-95 z-0 animate-gradient-shift"></div> {/* Animación de fondo */}

      {/* Estilos para animación de fondo (añadir a tu CSS o a un bloque style si usas Tailwind JIT con overrides) */}
      <style>
        {`
        @keyframes gradient-shift {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        .animate-gradient-shift {
          background-size: 200% 200%;
          animation: gradient-shift 15s ease infinite;
        }
        .fade-in-up {
          animation-fill-mode: both;
          animation-duration: 0.8s; /* Duración de la animación */
          animation-name: fade-in-up-keyframes;
          opacity: 0;
          transform: translateY(20px);
        }
        @keyframes fade-in-up-keyframes {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        `}
      </style>

      <main className="relative z-10 flex-grow container mx-auto px-4 py-12 flex flex-col items-center">
        {/* HERO */}
        <h1
          className="text-4xl sm:text-6xl font-extrabold mb-4 text-transparent bg-clip-text bg-gradient-to-r from-[#FFD700] via-[#DAA520] to-[#B8860B] text-center leading-tight fade-in-up" // CAMBIO: gradiente de amarillo a dorado
          style={{ animationDelay: '100ms' }}
        >
          {user ? `@${user.username}` : "Reprogramate"}
        </h1>

        <p
          className="text-2xl sm:text-4xl text-gray-100 text-center max-w-2xl mb-5 font-light fade-in-up" // Más grande y más ligera
          style={{ animationDelay: '250ms' }}
        >
          Liberate de tus bloqueos mentales en 5 semanas.
        </p>

        <p
          className="text-lg sm:text-xl text-gray-400 text-center max-w-xl mb-12 fade-in-up"
          style={{ animationDelay: '400ms' }}
        >
          Descubrí cómo vivir con claridad, confianza y propósito real.
        </p>


        {/* Transformación */}
        <h2
          className="text-xl sm:text-2xl font-bold mb-5 text-gray-300 text-center fade-in-up" // Título más grande
          style={{ animationDelay: '500ms' }}
        >
          Tu transformación empieza aquí:
        </h2>

        <div className="w-full flex flex-col items-center mb-10"> {/* Margen inferior aumentado */}
          <div
            className="w-full max-w-lg mx-auto mb-2 flex justify-between px-3 fade-in-up"
            style={{ animationDelay: '600ms' }}
          >
            <span className="text-sm text-gray-400">desde</span>
            <span className="text-sm text-gray-400">hacia</span>
          </div>
          {transformationData.map((data, index) => (
            <TransformationButton
              key={index}
              beforeText={data.before}
              afterText={data.after}
              beforeIcon={data.beforeIcon}
              afterIcon={data.afterIcon}
              index={index}
            />
          ))}
        </div>

        {/* CTA inicial */}
        <div className="w-full max-w-lg mx-auto mb-12 flex justify-center"> {/* Margen inferior aumentado */}
          <CTAButtons delay={1000} />
        </div>

        {/* Beneficios */}
        <InViewSection title="Lo que vas a lograr con este programa" index={0} id="beneficios">
          <ul className="list-none pl-0 text-gray-300 space-y-3"> {/* Eliminado list-disc y añadido space-y */}
            {benefits.map((b, i) => (
              <li key={i} className="flex items-center">
                <span className="text-green-400 mr-3 text-xl flex-shrink-0">{b.icon}</span> {/* Icono en cada beneficio */}
                <span>{b.text}</span>
              </li>
            ))}
          </ul>
        </InViewSection>

        {/* Testimonios */}
        <InViewSection title="Historias de transformación" index={1} id="testimonios"> {/* Título más evocador */}
          <div className="space-y-6"> {/* Espacio entre testimonios */}
            {testimonials.map((t, i) => (
              <blockquote key={i} className="border-l-4 border-[#DAA520] pl-4 italic text-gray-200 bg-gray-900/30 p-4 rounded-lg shadow-inner"> {/* CAMBIO: border-yellow-400 a border-[#DAA520] */}
                “{t.text}”
                <span className="block text-gray-400 mt-2 not-italic font-medium">– {t.author}, {t.role}</span> {/* Estilo de autor mejorado */}
              </blockquote>
            ))}
          </div>
        </InViewSection>

        {/* Para quién es */}
        <InViewSection
          title={
            <span className="flex items-center justify-center gap-2">
              <FaCheckCircle className="text-green-500 text-2xl" />
              <span>SI es para vos si...</span>
            </span>
          }
          index={2}
          id="para-quien"
        >
          <ul className="list-none pl-0 text-gray-200 space-y-2"> {/* Listado sin viñetas */}
            <li><span className="text-green-400 mr-2 text-lg">✔</span> Sentís que estás estancado/a y querés un cambio real.</li>
            <li><span className="text-green-400 mr-2 text-lg">✔</span> Buscás herramientas prácticas para elevar tu nivel de consciencia.</li>
            <li><span className="text-green-400 mr-2 text-lg">✔</span> Querés entender qué es realmente la manifestación y cómo aplicarla.</li>
            <li><span className="text-green-400 mr-2 text-lg">✔</span> Estás listo/a para desafiar tus límites y crecer.</li>
            <li><span className="text-green-400 mr-2 text-lg">✔</span> Valorás un enfoque holístico para tu bienestar.</li>
          </ul>
        </InViewSection>

        {/* No es para vos */}
        <InViewSection
          title={
            <span className="flex items-center justify-center gap-2">
              <FaTimesCircle className="text-red-500 text-2xl" />
              <span>NO es para vos si...</span>
            </span>
          }
          index={3}
        >
          <ul className="list-none pl-0 text-gray-200 space-y-2"> {/* Listado sin viñetas */}
            <li><span className="text-red-400 mr-2 text-lg">✖</span> Esperás soluciones mágicas sin compromiso personal.</li>
            <li><span className="text-red-400 mr-2 text-lg">✖</span> No querés explorar tus creencias y hábitos.</li>
            <li><span className="text-red-400 mr-2 text-lg">✖</span> Preferís culpar a factores externos en lugar de tomar acción.</li>
            <li><span className="text-red-400 mr-2 text-lg">✖</span> No estás abierto/a a nuevas perspectivas.</li>
          </ul>
        </InViewSection>

        {/* Sobre mí */}
        <InViewSection title="Conocé a tu guía:" index={4} id="sobre-mi"> {/* Título más descriptivo */}
          <img
            src={user?.profileImage || perfilImg}
            alt="Perfil de Gustavo Aguiar"
            className="w-32 h-32 sm:w-40 sm:h-40 rounded-full mb-5 object-cover border-4 border-[#DAA520] shadow-xl mx-auto transform hover:scale-105 transition-transform duration-300" // CAMBIO: border-yellow-400 a border-[#DAA520]
          />
          <h2 className="text-xl sm:text-3xl font-bold mb-2 text-center text-[#FFD700]">Gustavo Aguiar</h2> {/* CAMBIO: text-yellow-300 a text-[#FFD700] */}
          <p className="text-sm sm:text-base text-gray-300 text-center max-w-sm mx-auto leading-relaxed"> {/* Texto más legible */}
            Coach Holístico. Pasé años estancado en ansiedad y depresión. Dejé la medicación psiquiátrica y fui por mis sueños. Hoy acompaño a otros a despertar y vivir con propósito, confianza y ligereza. Mi misión es ayudarte a redescubrir tu poder interior.
          </p>
        </InViewSection>

        {/* Precio del Programa - NUEVA SECCIÓN */}
        <InViewSection title="Tu inversión en tu transformación" index={5} id="precio">
            <div className="text-center">
                <p className="text-4xl sm:text-5xl font-extrabold text-[#FFD700] mb-2"> {/* CAMBIO: text-yellow-300 a text-[#FFD700] */}
                    $177 <span className="text-xl sm:text-2xl text-gray-400">USD (pago único)</span>
                </p>
                <p className="text-2xl sm:text-3xl font-bold text-[#FFD700] mb-6"> {/* CAMBIO: text-yellow-300 a text-[#FFD700] */}
                    ó $40 <span className="text-lg text-gray-400">USD / semana</span>
                </p>
                <p className="text-lg text-gray-300 mb-6">
                    Acceso completo a todo el programa de 5 semanas.
                </p>
                <CTAButtons delay={0} /> {/* Se usa 0 de delay aquí ya que el padre InViewSection ya tiene su propio delay */}
            </div>
        </InViewSection>

        {/* FAQs - Índice ajustado */}
        <InViewSection title="Preguntas frecuentes" index={6} id="faqs">
          <div className="space-y-6"> {/* Espacio entre FAQs */}
            {faqs.map((f, i) => (
              <div key={i} className="bg-gray-900/30 p-4 rounded-lg shadow-inner"> {/* Estilo de FAQ mejorado */}
                <p className="font-bold text-[#FFD700] mb-1 flex items-center"> {/* CAMBIO: text-yellow-300 a text-[#FFD700] */}
                  <span className="mr-2 text-xl">?</span> {f.q}
                </p>
                <p className="text-gray-200">{f.a}</p>
              </div>
            ))}
          </div>
        </InViewSection>

        {/* CTA final - Delay ajustado */}
        <div className="w-full max-w-lg mx-auto mb-16 flex justify-center"> {/* Margen inferior aumentado */}
          <CTAButtons delay={1550} /> {/* Ajuste del delay */}
        </div>
      </main>

      {/* FOOTER - Delay ajustado */}
      <footer
        className="relative z-10 text-center py-8 text-xs text-gray-500 bg-black/50 border-t border-gray-800 fade-in-up" // Mejor fondo y borde
        style={{ animationDelay: '1700ms' }}
      >
        <div className="flex justify-center space-x-6 mb-3"> {/* Espacio entre iconos */}
          <a href="https://instagram.com/ingeniero.consciente" target="_blank" rel="noopener noreferrer" aria-label="Visita mi Instagram">
            <FaInstagram className="text-gray-400 hover:text-pink-500 text-2xl transition-colors duration-300" /> {/* Iconos más grandes y con hover */}
          </a>
        </div>
        <p>© {new Date().getFullYear()} Gustavo Aguiar | Acompañándote a vivir con propósito.</p>
        <p className="mt-1">Todos los derechos reservados.</p> {/* Añadido */}
      </footer>
    </div>
  );
};

export default MainCoursePage;